// extracted by mini-css-extract-plugin
export default {"description":"c36F7","decline":"o6Gbx"};